module.exports = __webpack_public_path__ + "static/plotly-fd4a4b9cd17a7cc22ce538798a3a5be8.png";